import { render, staticRenderFns } from "./ImportMappingsModal.vue?vue&type=template&id=77e72180&scoped=true"
import script from "./ImportMappingsModal.vue?vue&type=script&lang=js"
export * from "./ImportMappingsModal.vue?vue&type=script&lang=js"
import style0 from "./ImportMappingsModal.vue?vue&type=style&index=0&id=77e72180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e72180",
  null
  
)

export default component.exports